import clsx from 'clsx';
import * as React from 'react';
import type { SVGProps } from 'react';

/** Vertical segments from the original single path (split for per-bar animation). */
const WAVE_BAR_PATHS = [
  'M1.285 5.043v6.815',
  'M21.52 5.453v5.997',
  'M5.331 2.87v10.354',
  'M17.474 3.677v9.547',
  'M13.426 1.331V12.41',
  'M9.38 5.043v9.59',
] as const;

export type IconWaveProps = SVGProps<SVGSVGElement> & {
  /** When true, bars animate with a staggered up/down equalizer motion. */
  active?: boolean;
};

const IconWave = ({ active = false, className, ...props }: IconWaveProps) => {
  const clipId = React.useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="16"
      fill="none"
      className={className}
      {...props}
    >
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        clipPath={`url(#${clipId})`}
      >
        {WAVE_BAR_PATHS.map((d, i) => (
          <g
            key={d}
            className={clsx(
              active &&
                'motion-safe:origin-center motion-safe:animate-wave-eq motion-safe:[transform-box:fill-box]'
            )}
            style={active ? { animationDelay: `${i * 0.09}s` } : undefined}
          >
            <path d={d} />
          </g>
        ))}
      </g>
      <defs>
        <clipPath id={clipId}>
          <path fill="#fff" d="M0 0h22.805v15.964H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconWave;
